<template>
  <div>
    <div class="container">
      <div class="card_home">
        <div class="container-card">
          <p class="card-title-home">Atualizações!</p>
          <p class="card-description">1-Agora você pode interagir e tirar suas dúvidas com o nosso Robô. Teste agora mesmo enviando uma mensagem!</p>
        </div>
      </div>
      <div class="chat-container">
        <div style="display: flex; gap: 10px; padding: 10px;">
          <DxButton class="DxButton" icon="trash" type="success" text="Limpar" @click="limpar()" />
          <DxButton class="DxButton" icon="eyeopen" type="danger" text="Analisar os dados" @click="analiseIA()"/>
        </div>

        <div class="messages">
          <div v-for="msg in messages" :class="['message', msg.sender]" v-bind:key="msg">
              <table v-if="msg.text && msg.sender == 'chatbot'" class="table">
                <thead>
                    <tr class="tr">
                      <th v-for="(value, key) in msg.text[0]" :key="key" class="th">{{ key }}</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in msg.text" :key="index" class="tr">
                    <td class="td" v-for="(value, key) in item" :key="key">{{ value }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-if="msg.sender == 'user'" :class="['message', msg.sender]">
                {{ msg.text }}
              </div>
          </div>
          <DxLoadIndicator
            id="small-indicator"
            :height="20"
            :width="20"
            :visible="status"
          />
        </div>
        <input type="text" v-model="userMessage" @keyup.enter="sendMessage" placeholder="Digite sua mensagem...">
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import DxButton from 'devextreme-vue/button'
export default{
  data(){
    return{
      messages: [],
      userMessage: ''
    }
  },
  methods:{
    async sendMessage() {
      if (this.userMessage.trim() === '') return;
      this.messages.push({ text: this.userMessage, sender: 'user' });
      await this.getBotResponse(this.userMessage);
      this.userMessage = '';
    },
    limpar(){
      this.messages = []
    },
    async analiseIA(){
      //var resp_bot = await api.post_padrao(`chat/${user.nm_empresa}/send_mensagem`, { mensagem: userInput, from: user.nm_usuario })
    },
    async getBotResponse(userInput) {
      this.status = true
      var user = JSON.parse(localStorage.getItem('user'))
      console.log('USER', user)
      var resp_bot = await api.post_padrao(`chat/${user.nm_empresa}/send_mensagem`, { mensagem: userInput, from: user.nm_usuario })
      if(resp_bot.tipo == 'sql'){
        var json = {
          'script': resp_bot.resposta
        }
        this.messages.push({ text: await api.post('exec_sql', json), sender: resp_bot.from })
      }
      else{
        this.messages.push({ text: resp_bot.resposta, sender: resp_bot.from })
      }
      this.status = false
    }
  },
  components:{
    DxLoadIndicator,DxButton
  }
}
</script>
<style lang="scss">
.container {
  margin: 30px;
  //text-align: center;
  align-items: center;
}
.card_home {
  width: 100%;
  border: 0;
  margin-inline: auto;
}
.container-card {
  border: 2px solid var(--main_color);
  background-color: var(--main_color);
  border-radius: 20px;
  padding: 20px;
}
.card-title-home {
  font-weight: 600;
  color: rgb(255, 255, 255);
  letter-spacing: -0.02em;
  line-height: 40px;
  font-style: normal;
  font-size: 28px;
}
.card-description {
  font-weight: 600;
  color: hsl(0, 0%, 100%);
  font-size: 16px
}
.chat-container {
  margin-top: 15px;
  width: 100%;
  height: 500px;
  background: #f5f5f5;
  padding: 0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.messages {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  border-bottom: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message {
  max-width: 70%;
  padding: 10px 15px;
  border-radius: 16px;
  word-wrap: break-word;
  font-size: 15px;
}

.user {
  align-self: flex-end;
  background-color: #007bff;
  color: white;
}

.chatbot {
  align-self: flex-start;
  background-color: #e5e5ea;
  color: black;
}

.chat-container input {
  border-top: 1px solid #ddd;
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 0 0 10px 10px;
  outline: none;
}

.table {
  width: 100%;
  border-collapse: collapse;
}
.th, .td {
  padding: 8px;
  text-align: left;
}
.th {
  background-color: var(--main_color);
}

.button_clear_chat{
  width: 80px;
  border-radius: 20px;
  background-color: rgb(159, 159, 159);
  text-align: center;
}
</style>